import { Typography, Button, Input, Radio, IconButton } from '@material-tailwind/react'
import { FiTrash2 } from 'react-icons/fi'
import { OwnOfficeSelector as AccessOfficeSelector } from '@/shared/selectors/own-office-selector'

export const InviteForm = ({
  mode, setMode, date, setDate, startAt, setStartAt, endAt, setEndAt,
  officeId, setOfficeId, offices, officesLoading,
  invitees, setInvitees, handleSubmit, errorMsg, isLoading
}) => {
  const setInviteeField = (idx, field, value) =>
    setInvitees((arr) => arr.map((it, i) => (i === idx ? { ...it, [field]: value } : it)))

  return (
    <form onSubmit={handleSubmit} className="space-y-8">
      {/* Dependencia */}
      <div className="space-y-2">
        <div className="max-w-xl w-full">
          {officesLoading ? (
            <div className="text-sm text-gray-500">Cargando dependencias…</div>
          ) : (
            <AccessOfficeSelector
              instructions={false}
              offices={offices}
              officeId={officeId ?? 'all'}
              setOfficeId={(val) => setOfficeId((val === 'all' || !val) ? null : String(val))}
            />
          )}
        </div>
        {!officeId && (
          <Typography variant="small" color="red" className="mt-1">
            Selecciona una dependencia.
          </Typography>
        )}
      </div>

      {/* Tramo horario */}
      <div className="space-y-2">
        <Typography className="font-semibold">Tramo horario</Typography>
        <div className="flex flex-wrap gap-6">
          <Radio name="mode" label="Día completo" checked={mode === 'full_day'} onChange={() => setMode('full_day')} />
          <Radio name="mode" label="Rango" checked={mode === 'range'} onChange={() => setMode('range')} />
        </div>

        {mode === 'full_day' ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <Typography variant="small" className="mb-1 block">Fecha</Typography>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                className="block w-full min-w-0 rounded-md border border-gray-300 bg-white px-3 py-2 text-gray-900 text-[16px] focus:border-blue-500 focus:outline-none"
              />
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <Typography variant="small" className="mb-1 block">Inicio</Typography>
              <input
                type="datetime-local"
                value={startAt}
                onChange={(e) => setStartAt(e.target.value)}
                className="block w-full min-w-0 rounded-md border border-gray-300 bg-white px-3 py-2 text-gray-900 text-[16px] focus:border-blue-500 focus:outline-none"
              />
            </div>
            <div>
              <Typography variant="small" className="mb-1 block">Término</Typography>
              <input
                type="datetime-local"
                value={endAt}
                onChange={(e) => setEndAt(e.target.value)}
                className="block w-full min-w-0 rounded-md border border-gray-300 bg-white px-3 py-2 text-gray-900 text-[16px] focus:border-blue-500 focus:outline-none"
              />
            </div>
          </div>
        )}
      </div>

      {/* Invitados */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <Typography className="font-semibold">Invitados</Typography>
          <Button variant="outlined" size="sm" onClick={() => setInvitees(a => [...a, { name: '', email: '' }])}>
            Agregar invitado
          </Button>
        </div>

        {invitees.map((it, idx) => (
          <div key={idx} className="grid grid-cols-12 gap-3 items-end">
            <div className="col-span-12 sm:col-span-5">
              <Typography variant="small" className="mb-1 block">Nombre</Typography>
              <Input
                value={it.name}
                onChange={(e) => setInviteeField(idx, 'name', e.target.value)}
                containerProps={{ className: 'w-full min-w-0' }}
                className="!w-full min-w-0"
              />
            </div>
            <div className="col-span-12 sm:col-span-6">
              <Typography variant="small" className="mb-1 block">Email</Typography>
              <Input
                type="email"
                value={it.email}
                onChange={(e) => setInviteeField(idx, 'email', e.target.value)}
                containerProps={{ className: 'w-full min-w-0' }}
                className="!w-full min-w-0"
              />
            </div>
            <div className="col-span-12 sm:col-span-1 flex justify-end">
              {invitees.length > 1 && (
                <IconButton color="red" variant="text" onClick={() => setInvitees(a => a.filter((_, i) => i !== idx))}>
                  <FiTrash2 />
                </IconButton>
              )}
            </div>
          </div>
        ))}
      </div>

      {errorMsg && (
        <div className="bg-red-50 border border-red-200 text-red-800 rounded-lg p-3">{errorMsg}</div>
      )}

      <div className="flex justify-end">
        <Button type="submit" disabled={isLoading}>
          {isLoading ? 'Enviando…' : 'Enviar invitaciones'}
        </Button>
      </div>
    </form>
  )
}